export default "__VITE_PUBLIC_ASSET__cdd78525__"